@layer app {
  .container {
    width: 100%;
    color: var(--n-color-content-neutral-base);
    padding: 0 var(--n-scale-800);
    max-width: 850px;
    margin: auto;
  }

  .title {
    font-family: var(--n-font-family-heading);
    font-size: var(--n-font-size-800);
    font-weight: var(--n-font-weight-700);
    margin-bottom: var(--n-scale-100);
    text-align: center;
  }

  .withImage .title {
    text-align: left;
  }

  .description {
    font-size: var(--n-font-size-400);
    margin-bottom: var(--n-scale-600);
    text-align: center;
  }

  .withImage .description {
    text-align: left;
  }

  .left {
    align-items: center;
  }

  .withImage .left {
    align-items: flex-start;
  }

  .image {
    max-width: 320px;
    max-height: 320px;
    border-radius: var(--n-border-radius-max);
    object-fit: cover;
    object-position: center;
    box-shadow: var(--n-shadow-200);
    display: block;
  }

  @media (max-width: 700px) {
    .container {
      flex-direction: column;
      gap: var(--n-scale-400);
    }
    .right {
      margin-bottom: var(--n-scale-400);
    }
    .left {
      max-width: 100%;
      align-items: center;
      text-align: center;
      gap: var(--n-scale-200);
    }
    .image {
      margin-bottom: var(--n-scale-400);
    }
    .buttons {
      flex-direction: column;
      width: 100%;
      align-items: center;
    }
  }

  .buttons {
    display: flex;
    gap: var(--n-scale-200);
  }

  .right {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
